import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';

/** Marks the home-agent setup card done. The OGA tab save does not call this. */
export async function markContactPathDecided(workspaceId: string): Promise<void> {
  await setDoc(
    doc(db, `publicPages/${workspaceId}/settings`, 'onboarding'),
    {
      contactPathDecided: true,
      contactPathDecidedAt: serverTimestamp(),
    },
    { merge: true },
  );
}
